import React from "react";
import { Home, Search, Plus, Bell, User } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import routesPath from "@/utils/routesPath";

export default function MobileBottomNav() {
  const location = useLocation();
  const { DASHBOARD, PURCHASE_ORDER, NOTIFICATIONS } = routesPath;

  const navItems = [
    { icon: Home, path: DASHBOARD, label: "Home" },
    { icon: Search, path: "#", label: "Search" },
    { icon: Plus, path: "#", label: "Add" },
    { icon: Bell, path: NOTIFICATIONS, label: "Notifications" },
    { icon: User, path: "#", label: "Profile" },
  ];

  const isActive = (path: string) => {
    if (path === "#") return false;
    return location.pathname === path;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-[#1F2937] border-t border-gray-700 z-50 md:hidden">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          if (item.path === "#") {
            return (
              <button
                key={item.label}
                className={`flex flex-col items-center justify-center flex-1 h-full ${
                  active ? "text-green-500" : "text-gray-400"
                }`}
              >
                <Icon className="w-5 h-5 mb-1" />
              </button>
            );
          }

          return (
            <Link
              key={item.label}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full ${
                active ? "text-green-500" : "text-gray-400"
              }`}
            >
              <Icon className="w-5 h-5 mb-1" />
            </Link>
          );
        })}
      </div>
    </div>
  );
}
